import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { inferenceService, CatalogEntry } from '../services/inferenceApi';
import CompareSheet from '../components/catalog/CompareSheet';
import { Page, PageHeader, Skeleton } from '../components/console/ui';

export default function CompareModels() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['catalog'],
    queryFn: inferenceService.getCatalog,
  });

  const a = data?.models.find((m: CatalogEntry) => m.id === searchParams.get('a'));
  const b = data?.models.find((m: CatalogEntry) => m.id === searchParams.get('b'));
  const notFound = !a || !b || a.id === b.id;

  return (
    <Page>
      <PageHeader
        eyebrow="Inference · Models"
        title="Compare models"
        subtitle="Side by side on price, context and specs."
        actions={
          <button type="button" onClick={() => navigate('/console/models')} className="ps-btn2">
            ← Back to models
          </button>
        }
      />

      {isError ? (
        <div className="ps-card flex flex-col items-center gap-4 px-6 py-14 text-center text-sm text-ps-err">
          <p className="m-0">Could not load the model catalog.</p>
          <Link to="/console/models" className="ps-btn ps-btn-sm">
            Browse models
          </Link>
        </div>
      ) : isLoading ? (
        <Skeleton className="h-96 rounded-[14px]" />
      ) : notFound ? (
        <div className="ps-card flex flex-col items-center gap-4 px-6 py-14 text-center">
          <p className="m-0 text-sm text-ps-muted">Pick two models to compare.</p>
          <Link to="/console/models" className="ps-btn ps-btn-sm">
            Browse models
          </Link>
        </div>
      ) : (
        <>
          <CompareSheet a={a} b={b} currency={data?.currency ?? 'INR'} />
          <div className="flex flex-wrap gap-2.5">
            {[a, b].map((m, i) => (
              <Link
                key={m.id}
                to={`/console/playground?model=${encodeURIComponent(m.display_name)}`}
                className={i === 0 ? 'ps-btn' : 'ps-btn2'}
              >
                Try {m.display_name} →
              </Link>
            ))}
            <Link to="/console/keys" className="ps-btn2">
              Create API key
            </Link>
          </div>
        </>
      )}
    </Page>
  );
}
